import React from 'react'

const OneHealthcareIdLogin = () => {
  React.useEffect(() => {
    //var origin= window.location.origin;
    //http://localhost:3002/
    //process.env.REACT_APP_UI_HOME = window.location.origin;
    if (
      process.env.REACT_APP_DEVELOPMENT_MODE === undefined ||
      process.env.REACT_APP_DEVELOPMENT_MODE === 'true'
    ) {
      window.location.replace('/oauth2/login-redirect')
    } else {

      fetch(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/login/url?type=${window.location.origin}`
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error('Failed to fetch login URL')
          }
          return response.json()
        })
        .then((data) => {
          console.log('Redirecting to:', data.url)
          window.location.replace(data.url)
        })
        .catch((error) => {
          console.error('Error fetching login URL:', error)
        })

      // fetch(`${process.env.REACT_APP_BACKEND_BASE_URL}/login/url`, {
      //   method: 'POST',
      //   body : JSON.stringify({
      //     type : window.location.origin
      //   })
      // })
      //  .then((response) => response.json())
      // .then((data) => window.location.replace(data.url))
    }
  }, [])
const wrapperStyle = {
    minHeight: '60vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px'
  }

  const cardStyle = {
    background: 'white',
    borderRadius: 12,
    boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
    padding: '28px 30px',
    maxWidth: 420,
    width: '100%',
    textAlign: 'center',
    boxSizing: 'border-box'
  }

  const titleStyle = {
    fontSize: 18,
    fontWeight: 600,
    marginBottom: 8,
    color: '#102A43'
  }

  const subtitleStyle = {
    fontSize: 14,
    marginBottom: 18,
    color: '#334E68'
  }

  const spinnerStyle = {
    width: 48,
    height: 48,
    borderRadius: '50%',
    border: '4px solid rgba(16,42,67,0.12)',
    borderTopColor: '#0B66C2',
    animation: 'spin 1s linear infinite',
    margin: '0 auto 14px'
  }

  return (
    <div style={wrapperStyle}>
      <div style={cardStyle}>
        <div style={spinnerStyle} aria-hidden="true" />
        <div style={titleStyle}>Redirecting to OneHealthcare Login</div>
        <div style={subtitleStyle}>You will be sent to the secure login page shortly.</div>
        <div style={{ fontSize: 13, color: '#627D98' }}>If you are not redirected automatically, please wait or check your browser settings.</div>

        {/* simple keyframes for the spinner; injected via style tag to keep file self-contained */}
        <style>{`@keyframes spin { from { transform: rotate(0deg) } to { transform: rotate(360deg) } }`}</style>
      </div>
    </div>
  )
}

export default OneHealthcareIdLogin
